export default __webpack_public_path__ + "static/media/ilus-bg.f92af023.svg";